import axios from 'axios';

/**
 * Calls the Mushin Lambda notifier (API Gateway).
 * Payload shape matches your serverless handler: channel, to, subject, html (email).
 */
export async function sendNotification({ channel = 'email', to, subject, html, message }) {
  const url = 'https://y98h049oei.execute-api.ap-south-1.amazonaws.com/prod/mushinLambdaNotifier';
  const apiKey = 'zZEirjTOLT7lhEwTJ0WXz51uuKQIoAXL4tiRFLUs';


  if (!url || !apiKey) {
    throw new Error(
      'Email notifier is not configured. Set REACT_APP_MUSHIN_NOTIFIER_URL and REACT_APP_MUSHIN_NOTIFIER_API_KEY.',
    );
  }

  const body = { channel, to, subject };
  if (html != null) body.html = html;
  if (message != null) body.message = message;

  const response = await axios.post(url, body, {
    headers: {
      'x-api-key': apiKey,
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

/** Send the same HTML email to multiple addresses (parallel). */
export async function sendGroupMail(emails, subject, html) {
  const sendPromises = emails.map(async (email) => {
    try {
      const res = await sendNotification({
        channel: 'email',
        to: email,
        subject,
        html,
      });
      return { email, status: 'success', response: res };
    } catch (error) {
      return {
        email,
        status: 'error',
        error: error.response?.data || error.message || String(error),
      };
    }
  });
  return Promise.all(sendPromises);
}
